import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AddTaxRate$Params } from 'src/api/generated/fn/tax-rate-v-2/add-tax-rate';
import { UpdateTaxRate_1$Params } from 'src/api/generated/fn/tax-rate-v-2/update-tax-rate-1';
import { AddTaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/add-tax-rate-v-2-dto';
import { TaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { UpdateTaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/update-tax-rate-v-2-dto';
import { TaxRateV2Service } from 'src/api/generated/services';

@Component({
  selector: 'app-add-or-edit-tax-rate',
  templateUrl: './add-or-edit-tax-rate.component.html',
  styleUrls: ['./add-or-edit-tax-rate.component.scss']
})
export class AddOrEditTaxRateComponentV2 implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();
  public editFlag: boolean = false;
  public taxRateDto: TaxRateV2Dto = {} as TaxRateV2Dto;
  public companyId: string;
  public taxRateId: string;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private taxRateService: TaxRateV2Service,
  ) {

    if (this.config.data != undefined) {
      if (this.config.data.item) {
        this.taxRateDto.name = this.config.data.item.name;
        this.taxRateDto.rate = this.config.data.item.rate;
        this.taxRateDto.description = this.config.data.item.description;
        this.taxRateId = this.config.data.item.id;
        this.editFlag = true;
      }
      if (this.config.data.companyId) {
        this.companyId = this.config.data.companyId;
      }
    }
   }

  ngOnInit(): void {
  }

  addTaxRate(f: NgForm) {
    if(f.valid){
      const addTaxRateDto: AddTaxRateV2Dto = { companyId: this.companyId, description: this.taxRateDto.description, name: this.taxRateDto.name, rate: this.taxRateDto.rate};
      var params: AddTaxRate$Params = {} as AddTaxRate$Params;
      params.body = addTaxRateDto;
      this.taxRateService.addTaxRate(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }

  editTaxRate(f: NgForm) {
    if(f.valid){
      const updateTaxRateDto: UpdateTaxRateV2Dto = { name: this.taxRateDto.name, rate: this.taxRateDto.rate, description: this.taxRateDto.description };
      var params: UpdateTaxRate_1$Params = {} as UpdateTaxRate_1$Params;
      params.taxRateId = this.taxRateId;
      params.body = updateTaxRateDto;
      this.taxRateService.updateTaxRate_1(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }

  close() {
    this.ref.close(null);
  }
}
